<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">资产总览</div>
			<div style="color: #409eff; font-size: 14px; cursor: pointer" @click="goPage('/pages/asset/assetLedger')">
				更多
			</div>
		</div>

		<div class="overview-grid">
			<div
				class="overview-item"
				v-for="(item, index) in overviewList"
				:key="index"
				:style="{
					'--color': item.color,
				}"
				@click="goPage(item.url)">
				<div class="label">
					<div>
						{{ item.label }}
					</div>
					<div class="tip" v-if="item.info">
						<el-tooltip
							class="item"
							effect="dark"
							content="整体出租率=已出租数量/（已出租数量+已预订数量+空置可租数量）"
							placement="top">
							<i class="fa fa-question-circle-o" style="color: #999; font-size: 14px"></i>
						</el-tooltip>
					</div>
				</div>
				<div class="value">{{ item.value }}{{ item.unit }}</div>
			</div>
		</div>
	</el-card>
</template>

<script>
	export default {
		name: 'AssetOverview',
		props: {
			assetOverview: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				overviewList: [
					{
						key: 'assetCount',
						label: '资产数量',
						value: '0',
						unit: '个',
						color: '#0F172A',
						url: '/pages/asset/assetLedger',
					},
					{
						key: 'buildingArea',
						label: '资产面积(㎡)',
						value: '0',
						unit: '万',
						color: '#0F172A',
						url: '/pages/asset/assetLedger',
					},
					{
						key: 'useArea',
						label: '出租面积(㎡)',
						value: '0',
						unit: '万',
						color: '#0F172A',
						url: '/pages/assets/rentControlChart',
					},
					{
						key: 'rentRate',
						label: '整体出租率',
						value: '0',
						unit: '%',
						color: '#22C55E',
						info: true,
						url: null,
					},
					{
						key: 'pendingAssets',
						label: '闲置资产',
						value: '0',
						unit: '个',
						color: '#F97316',
						url: '/pages/asset/assetPlan',
					},
				],
			};
		},
		watch: {
			assetOverview: {
				handler(newVal) {
					if (!newVal) return;
					this.overviewList.forEach(item => {
						item.value = newVal[item.key] !== undefined ? newVal[item.key] : '0';
					});
				},
			},
		},
		methods: {
			goPage(url) {
				if (!url) return;
				this.$router.push(url);
			},
		},
	};
</script>

<style scoped lang="scss">
	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}

	.title {
		font-weight: bold;
	}

	.overview-grid {
		display: flex;
		justify-content: flex-start;
		gap: 12px;

		.overview-item {
			min-width: calc(100% / 5 - 12px);
			padding: 12px;
			border-radius: 10px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all 0.3s ease;

			.label {
				font-size: 12px;
				color: #3e3e3e;
				margin-bottom: 4px;
				display: flex;
				align-items: center;
				gap: 8px;
			}

			.tip {
				cursor: help;
			}

			.value {
				font-size: 24px;
				font-weight: bold;
				color: var(--color);
			}
		}

		.overview-item:hover {
			border-color: var(--color);
			background-color: color-mix(in srgb, var(--color) 10%, white);
			transform: translateY(-4px);
		}
	}
</style>
